(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 29792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(35727);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FW": function() { return /* binding */ getScripure; },
/* harmony export */   "G3": function() { return /* binding */ getLanguage; },
/* harmony export */   "UQ": function() { return /* binding */ getPages; },
/* harmony export */   "dS": function() { return /* binding */ getThirumurai; },
/* harmony export */   "mM": function() { return /* binding */ getPagesContentBySubCategory; },
/* harmony export */   "pT": function() { return /* binding */ getTemples; },
/* harmony export */   "zj": function() { return /* binding */ getSubCategories; }
/* harmony export */ });
/* unused harmony exports getPagesContent, getPagesList, getSubCategoryDetail */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23215);



var getPagesContentBySubCategory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(uri, pageNo) {
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", fetch("".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/pages?filters[sub_category][Sub_category_URL][$eq]=").concat(uri, "&sort=page_order:ASC&pagination[page]=").concat(pageNo ? pageNo : 1, "&pagination[pageSize]=10&fields[0]=Page_title&fields[1]=Page_url")).then(function(res) {
                        return res.json();
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPagesContentBySubCategory(uri, pageNo) {
        return _ref.apply(this, arguments);
    };
}();
var getPagesContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
        var uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/pages?filters[Page_url][$eq]=").concat(url, "&populate[seo][populate]=*");
                    console.log("URI ==>", uri);
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPagesContent(url) {
        return _ref.apply(this, arguments);
    };
}();
var getPagesList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(filter) {
        var uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/pages?").concat(filter, "&populate[sub_category][fields][0]=Sub_category_URL");
                    console.log("uri is =>", uri);
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPagesList(filter) {
        return _ref.apply(this, arguments);
    };
}();
var getSubCategoryDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url) {
        var uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/sub-categories?filters[Sub_category_URL][$eq]=").concat(url, "&populate[seo][populate]=*&fields[0]=Sub_category_Title&fields[1]=Sub_category_URL&fields[2]=description&fields[3]=autoGenerated");
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSubCategoryDetail(url) {
        return _ref.apply(this, arguments);
    };
}();
var getSubCategories = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var queryKey, ref, pageParam, text, filter, uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryKey = param.queryKey;
                    ref = queryKey[1], pageParam = ref.pageParam, text = ref.text, filter = ref.filter;
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/sub-categories?filters[Sub_category_Title][$contains]=").concat(text, "&fields[0]=Sub_category_Title&fields[1]=Sub_category_URL&pagination[page]=").concat(pageParam, "&pagination[pageSize]=10&").concat((filter === null || filter === void 0 ? void 0 : filter.split(":")[0]) !== "" ? "sort=".concat(filter) : "");
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSubCategories(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPages = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var queryKey, ref, pageParam, text, filter, uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryKey = param.queryKey;
                    ref = queryKey[1], pageParam = ref.pageParam, text = ref.text, filter = ref.filter;
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/pages?filters[Page_title][$contains]=").concat(text, "&fields[0]=Page_title&fields[1]=Page_url&populate[sub_category]=Sub_category_URL&pagination[page]=").concat(pageParam, "&pagination[pageSize]=10&").concat((filter === null || filter === void 0 ? void 0 : filter.split(":")[0]) !== "" ? "sort=".concat(filter) : "");
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPages(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLanguage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var queryKey, ref, pageParam, text, filter, uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryKey = param.queryKey;
                    ref = queryKey[1], pageParam = ref.pageParam, text = ref.text, filter = ref.filter;
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/languages?filters[name][$contains]=").concat(text, "&fields[0]=name&pagination[page]=").concat(pageParam, "&pagination[pageSize]=10&").concat((filter === null || filter === void 0 ? void 0 : filter.split(":")[0]) !== "" ? "sort=".concat(filter) : "");
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLanguage(_) {
        return _ref.apply(this, arguments);
    };
}();
var getTemples = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var queryKey, ref, pageParam, text, filter, uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryKey = param.queryKey;
                    ref = queryKey[1], pageParam = ref.pageParam, text = ref.text, filter = ref.filter;
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/temples?filters[Name_of_the_place][$contains]=").concat(text, "&fields[0]=Name_of_the_place&fields[1]=Temples_Url&pagination[page]=").concat(pageParam, "&pagination[pageSize]=10&").concat((filter === null || filter === void 0 ? void 0 : filter.split(":")[0]) !== "" ? "sort=".concat(filter) : "");
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTemples(_) {
        return _ref.apply(this, arguments);
    };
}();
var getScripure = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var queryKey, ref, pageParam, text, filter, uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryKey = param.queryKey;
                    ref = queryKey[1], pageParam = ref.pageParam, text = ref.text, filter = ref.filter;
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/scriptures?filters[Scripture_title][$contains]=").concat(text, "&fields[0]=Scripture_title&fields[1]=Scripture_url&populate[language]=name&pagination[page]=").concat(pageParam, "&pagination[pageSize]=10&").concat((filter === null || filter === void 0 ? void 0 : filter.split(":")[0]) !== "" ? "sort=".concat(filter) : "");
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getScripure(_) {
        return _ref.apply(this, arguments);
    };
}();
var getThirumurai = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var queryKey, ref, pageParam, text, filter, uri;
        return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryKey = param.queryKey;
                    ref = queryKey[1], pageParam = ref.pageParam, text = ref.text, filter = ref.filter;
                    uri = "".concat(_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .Config.BaseUrl */ .D.BaseUrl, "/thirumurais?filters[Thirumurai_title][$contains]=").concat(text, "&fields[0]=Thirumurai_title&fields[1]=Thirumurai_url&populate[trimurai_category]=url&pagination[page]=").concat(pageParam, "&pagination[pageSize]=10&").concat((filter === null || filter === void 0 ? void 0 : filter.split(":")[0]) !== "" ? "sort=".concat(filter) : "");
                    return _ctx.abrupt("return", fetch(uri).then(function(res) {
                        return res.json();
                    }));
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getThirumurai(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 21943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_BredCrum_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74072);
/* harmony import */ var _styles_BredCrum_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_BredCrum_module_css__WEBPACK_IMPORTED_MODULE_3__);






var Bredcrum = function(param) {
    var _slug = param.slug, slug = _slug === void 0 ? [] : _slug, _additionalInfo = param.additionalInfo, additionalInfo = _additionalInfo === void 0 ? "" : _additionalInfo;
    var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
        if (!string) return;
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(router.asPath.slice(1, -1)), path = ref2[0], setpath = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((ref1 = (ref = path === null || path === void 0 ? void 0 : path.split("/")) === null || ref === void 0 ? void 0 : ref.filter(function(i) {
        return i !== "#gsc.tab=";
    })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 2)), splitPath = ref3[0], setsplitPath = ref3[1];
    var pathHandle = function(param) {
        var item = param.item, index = param.index;
        if (index == 0 && splitPath.length == 1) {
            return;
        }
        if (index == 2 && splitPath.length == 3) {
            return;
        }
        if (index == 1 && splitPath.length == 2) {
            return;
        }
        if (additionalInfo !== "" && splitPath.length == 2) {
            router.push("".concat(additionalInfo, "/").concat(item));
            return;
        }
        router.push("/".concat(item));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (slug.length > 0) {
            setsplitPath(slug);
        }
    }, [
        slug
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_BredCrum_module_css__WEBPACK_IMPORTED_MODULE_3___default().Bredcrum),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                style: {
                    fontFamily: "Lora",
                    fontWeight: "bold"
                },
                onClick: function() {
                    return router.push("/");
                },
                children: "Home > "
            }),
            additionalInfo !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                style: {
                    fontFamily: "Lora",
                    fontWeight: "bold"
                },
                onClick: function() {
                    return router.push("".concat(additionalInfo));
                },
                children: [
                    capitalizeFirstLetter("".concat(additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.split("/")[1])),
                    " > "
                ]
            }),
            splitPath === null || splitPath === void 0 ? void 0 : splitPath.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_BredCrum_module_css__WEBPACK_IMPORTED_MODULE_3___default().h2),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                        style: {
                            color: index == 0 && splitPath.length == 1 || index == 1 && splitPath.length == 2 ? "rgba(0, 0, 0, 0.275)" : "black"
                        },
                        onClick: function() {
                            return pathHandle({
                                item: item,
                                index: index
                            });
                        },
                        children: [
                            " ",
                            item,
                            " ",
                            index === splitPath.length - 1 ? "" : ">",
                            "  "
                        ]
                    })
                }, item);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Bredcrum);


/***/ }),

/***/ 37215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_ReleatedContentCard_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81339);
/* harmony import */ var _styles_ReleatedContentCard_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_ReleatedContentCard_module_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ReleatedContentCard = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_ReleatedContentCard_module_css__WEBPACK_IMPORTED_MODULE_3___default().articles__list__item),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_ReleatedContentCard_module_css__WEBPACK_IMPORTED_MODULE_3___default().content),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                    children: [
                        " ",
                        props.title.slice(0, 60),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_ReleatedContentCard_module_css__WEBPACK_IMPORTED_MODULE_3___default().btn),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                    className: (_styles_ReleatedContentCard_module_css__WEBPACK_IMPORTED_MODULE_3___default().readmore),
                    style: {
                        cursor: "pointer"
                    },
                    onClick: function() {
                        return router.push(props.uri);
                    },
                    children: [
                        "Read more ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assests/icons/right.png",
                            alt: ""
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReleatedContentCard);


/***/ }),

/***/ 68723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_SocialMedia_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57688);
/* harmony import */ var _styles_SocialMedia_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_SocialMedia_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _data_social_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97776);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21818);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51649);









var SocialMedia = function() {
    var globalselectedlang = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.language.globalLang;
    });
    var shareText = _data_social_json__WEBPACK_IMPORTED_MODULE_3__[globalselectedlang ? globalselectedlang : "en"].share;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), path = ref[0], setPath = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), copy = ref1[0], setCopy = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setPath(window.location.href);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_SocialMedia_module_css__WEBPACK_IMPORTED_MODULE_5___default().links),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span1", {
                    children: "Share this page"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_6__/* .TwitterShareButton */ .B, {
                    url: path,
                    title: shareText,
                    separator: "::",
                    hashtag: "#shaivam",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assests/icons/twitter.svg",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_6__/* .FacebookShareButton */ .Dk, {
                    url: "https://shaivam.org",
                    text: "next-share is a social share buttons for your next React apps.",
                    quote: "next-share is a social share buttons for your next React apps.",
                    hashtag: "#shaivam",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/assests/icons/fb.svg",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_6__/* .WhatsappShareButton */ .N0, {
                    url: path,
                    title: shareText,
                    separator: "::",
                    hashtag: "#shaivam",
                    style: {
                        marginRight: "10px"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_7__/* .IoLogoWhatsapp */ .ff9, {
                        fontSize: 26,
                        style: {
                            color: "#C45D4E"
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: "|"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_2__.CopyToClipboard, {
                    className: (_styles_SocialMedia_module_css__WEBPACK_IMPORTED_MODULE_5___default().share),
                    onCopy: function() {
                        return setCopy(true);
                    },
                    text: path,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/assests/icons/link.svg",
                                alt: ""
                            }),
                            " ",
                            copy ? "link copied" : "Copy link"
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SocialMedia);


/***/ }),

/***/ 35727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10797);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_SocialMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68723);
/* harmony import */ var semantic_ui_css_semantic_min_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73014);
/* harmony import */ var semantic_ui_css_semantic_min_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(semantic_ui_css_semantic_min_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89696);
/* harmony import */ var _styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _api_pageDetailsApi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93909);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_ReleatedContentCard__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37215);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58533);
/* harmony import */ var semantic_ui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61118);
/* harmony import */ var _components_Bredcrum__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21943);
/* harmony import */ var _utils_Helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68340);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9473);
/* harmony import */ var _actions_audioSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85947);





// import Header from "../components/Header";













var OptionalPages = function(param) {
    var slug = param.slug, subCategory = param.subCategory, subCategoryPages = param.subCategoryPages, page = param.page, relatedContent = param.relatedContent;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var AudioOptions = [];
    var ref24 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), data = ref24[0], setData = ref24[1];
    var ref25 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), hasMore = ref25[0], setHasMore = ref25[1];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_12__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setData([]);
        setHasMore(true);
    }, [
        slug[0]
    ]);
    var tempList = (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_11__/* .formatAudio */ .al)(page === null || page === void 0 ? void 0 : (ref = page.attributes) === null || ref === void 0 ? void 0 : ref.Audio_url);
    if ((tempList === null || tempList === void 0 ? void 0 : tempList.length) > 0) {
        var _AudioOptions;
        var content = tempList === null || tempList === void 0 ? void 0 : tempList.map(function(item, i) {
            var ref, ref1;
            return {
                key: i,
                text: item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.title,
                value: item === null || item === void 0 ? void 0 : (ref1 = item.attributes) === null || ref1 === void 0 ? void 0 : ref1.rawURL
            };
        });
        (_AudioOptions = AudioOptions).push.apply(_AudioOptions, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(content));
    }
    var handlePlay = function(_, param) {
        var value = param.value;
        var index = AudioOptions === null || AudioOptions === void 0 ? void 0 : AudioOptions.findIndex(function(sr, i) {
            return sr.value === value;
        });
        dispatch((0,_actions_audioSlice__WEBPACK_IMPORTED_MODULE_13__/* .updateSongs */ .ZE)({
            songs: tempList
        }));
        dispatch((0,_actions_audioSlice__WEBPACK_IMPORTED_MODULE_13__/* .audioInfoChange */ .mx)({
            songIndex: index === -1 ? 0 : index,
            album: ""
        }));
        dispatch((0,_actions_audioSlice__WEBPACK_IMPORTED_MODULE_13__/* .updateIndex */ .RF)(index === -1 ? 0 : index));
        dispatch((0,_actions_audioSlice__WEBPACK_IMPORTED_MODULE_13__/* .audioStateChange */ .Xk)(true));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: page ? page === null || page === void 0 ? void 0 : (ref1 = page.attributes) === null || ref1 === void 0 ? void 0 : ref1.Page_title : subCategory === null || subCategory === void 0 ? void 0 : (ref2 = subCategory.attributes) === null || ref2 === void 0 ? void 0 : ref2.Sub_category_Title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1.0, width=device-width"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: page ? page === null || page === void 0 ? void 0 : (ref3 = page.attributes) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.seo) === null || ref4 === void 0 ? void 0 : ref4.metaDescription : subCategory === null || subCategory === void 0 ? void 0 : (ref5 = subCategory.attributes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.seo) === null || ref6 === void 0 ? void 0 : ref6.metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "keywords",
                        content: page ? page === null || page === void 0 ? void 0 : (ref7 = page.attributes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.seo) === null || ref8 === void 0 ? void 0 : ref8.metaKeyword : subCategory === null || subCategory === void 0 ? void 0 : (ref9 = subCategory.attributes) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.seo) === null || ref10 === void 0 ? void 0 : ref10.metaKeyword
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:title",
                        content: page ? page === null || page === void 0 ? void 0 : (ref11 = page.attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.seo) === null || ref12 === void 0 ? void 0 : ref12.metaTitle : subCategory === null || subCategory === void 0 ? void 0 : (ref13 = subCategory.attributes) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.seo) === null || ref14 === void 0 ? void 0 : ref14.metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:description",
                        content: page ? page === null || page === void 0 ? void 0 : (ref15 = page.attributes) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.seo) === null || ref16 === void 0 ? void 0 : ref16.metaDescription : subCategory === null || subCategory === void 0 ? void 0 : (ref17 = subCategory.attributes) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.seo) === null || ref18 === void 0 ? void 0 : ref18.metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "icon",
                        href: "/assests/icons/logo.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().hinduWrapper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().social),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().path),
                                children: [
                                    slug && slug[1] == undefined && slug[0] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Bredcrum__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        slug: slug
                                    }),
                                    slug && slug[0] && slug[1] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Bredcrum__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        slug: slug
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().socailMediaShare),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_SocialMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            }),
                            page && (page === null || page === void 0 ? void 0 : (ref19 = page.attributes) === null || ref19 === void 0 ? void 0 : ref19.Audio_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().socailMediaShare),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(semantic_ui_react__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    clearable: true,
                                    selection: true,
                                    placeholder: "Please select a Audio",
                                    options: AudioOptions,
                                    onChange: handlePlay
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().HinduTitle),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: "/assests/icons/om.png",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                                children: [
                                    subCategory && !page ? subCategory === null || subCategory === void 0 ? void 0 : (ref20 = subCategory.attributes) === null || ref20 === void 0 ? void 0 : ref20.Sub_category_Title : null,
                                    page ? page === null || page === void 0 ? void 0 : (ref21 = page.attributes) === null || ref21 === void 0 ? void 0 : ref21.Page_title : null
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: "/assests/icons/om.png",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {})
                        ]
                    }),
                    subCategory && !page ? (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_11__/* .SetRichTextContent */ .eX)(subCategory === null || subCategory === void 0 ? void 0 : (ref22 = subCategory.attributes) === null || ref22 === void 0 ? void 0 : ref22.description) : null,
                    (subCategory === null || subCategory === void 0 ? void 0 : subCategory.attributes.autoGenerated) == "Yes" && subCategoryPages ? SubCategoryPagesContent(subCategoryPages, slug[0], data, setData, hasMore, setHasMore) : null,
                    page ? (0,_utils_Helper__WEBPACK_IMPORTED_MODULE_11__/* .SetRichTextContent */ .eX)(page === null || page === void 0 ? void 0 : (ref23 = page.attributes) === null || ref23 === void 0 ? void 0 : ref23.description) : null,
                    RelatedContent(relatedContent)
                ]
            })
        ]
    });
};
function SubCategoryPagesContent(list, uri, data, setData, hasMore, setHasMore) {
    var getMorePost = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, pageNo, res;
            return _workspace_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        pageNo = (list.length + data.length) / 10 + 1;
                        console.log("pageNo", pageNo);
                        _ctx.next = 5;
                        return (0,_api_pageDetailsApi__WEBPACK_IMPORTED_MODULE_5__/* .getPagesContentBySubCategory */ .mM)(uri, pageNo);
                    case 5:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                            setData((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(data).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(res.data)));
                            if (res.data.length < 10) {
                                setHasMore(false);
                            }
                            setHasMore(true);
                        } else {
                            setHasMore(false);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getMorePost() {
            return _ref.apply(this, arguments);
        };
    }();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().hinduContent),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            dataLength: list.length + data.length,
            next: getMorePost,
            hasMore: hasMore,
            loader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                children: " Loading..."
            }),
            scrollThreshold: 0.5,
            endMessage: "",
            children: [
                list.map(function(param) {
                    var attributes = param.attributes, id = param.id;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                onClick: function() {
                                    return router.push("/".concat(uri, "/").concat(attributes === null || attributes === void 0 ? void 0 : attributes.Page_url));
                                },
                                children: attributes === null || attributes === void 0 ? void 0 : attributes.Page_title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {})
                        ]
                    }, id);
                }),
                data.map(function(param) {
                    var attributes = param.attributes, id = param.id;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                onClick: function() {
                                    return router.push("/".concat(uri, "/").concat(attributes === null || attributes === void 0 ? void 0 : attributes.Page_url));
                                },
                                children: attributes === null || attributes === void 0 ? void 0 : attributes.Page_title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {})
                        ]
                    }, id);
                })
            ]
        })
    });
}
function RelatedContent(content) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().releatedHeading),
                children: " Related Content "
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().reletedCardWrapper),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_styles_Slug_module_css__WEBPACK_IMPORTED_MODULE_15___default().reletedCard),
                    children: content === null || content === void 0 ? void 0 : content.map(function(item, index) {
                        var ref, ref1, ref2, ref3;
                        var url = "/" + ((ref1 = item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.sub_category.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.Sub_category_URL) + "/" + (item === null || item === void 0 ? void 0 : (ref3 = item.attributes) === null || ref3 === void 0 ? void 0 : ref3.Page_url);
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ReleatedContentCard__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            title: item === null || item === void 0 ? void 0 : item.attributes.Page_title,
                            uri: url
                        }, index);
                    })
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (OptionalPages);


/***/ }),

/***/ 74072:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Bredcrum":"BredCrum_Bredcrum__m7PbD"};

/***/ }),

/***/ 81339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articles__list__item":"ReleatedContentCard_articles__list__item__7wvB8","artTitle":"ReleatedContentCard_artTitle__feRnM","articlesTitle":"ReleatedContentCard_articlesTitle__of_XW","content":"ReleatedContentCard_content__PoESj","btn":"ReleatedContentCard_btn__zPuob"};

/***/ }),

/***/ 57688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"links":"SocialMedia_links__HD0oz","share":"SocialMedia_share__sxRaY"};

/***/ }),

/***/ 97776:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"en":{"share":"I found this information in Shaivam.org interesting. Since it is relevant I want to share this with you."},"ta":{"share":"இந்த சுவையான தகவலை Shaivam.org ல் கண்டேன். இது பொருத்தமானது என்பதால் இதை உங்களுடன் பகிர்ந்து கொள்ள விரும்புகிறேன்."},"hi":{"share":"मुझे यह जानकारी Shaivam.org में दिलचस्प लगी। चूंकि यह प्रासंगिक है, इसलिए मैं इसे आपके साथ साझा करना चाहता हूं।"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9866,3914,5049,1118,4022,9774,2888,179], function() { return __webpack_exec__(29792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);